import React from 'react';
import { useGetOptions, SelectInputProps } from "../../../../../hooks/report/useGetOptions";
import { BoundSelect } from "../BoundSelect";
import { BookingDurationType } from "../../../../constants/securspace-constants";

type BoundDurationTypeSelectProps<T> = {
  label?: string;
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundDurationTypeSelect = <T,>({
  label = "Duration Type",
  name,
  value = '',
  onChange
}: BoundDurationTypeSelectProps<T>) => {

  return <BoundSelect<T>
    options={useGetOptions({optionFormat: 'SELECT', options: BookingDurationType}) as unknown as SelectInputProps[]}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
}

export { BoundDurationTypeSelect };